import React, { PropsWithChildren } from 'react'
import { logoutServer } from '../api/aggregationApi'
import { useServerSession } from '../hooks/useServerSession'
import { ButtonState } from '../models/ButtonState'
import { Button } from './Button'

export function Settings({
  children,
  className = '',
}: PropsWithChildren<{ className: string }>) {
  const { sessionInfo } = useServerSession()
  const [logoutState, setLogoutState] = React.useState<ButtonState>('idle')

  function handleLogout(): Promise<void> {
    setLogoutState('pending')
    return logoutServer().finally(() => {
      window.location.reload()
    })
  }

  return (
    <div
      className={`${className} bg-white shadow overflow-hidden sm:rounded-lg content-center mx-4`}
    >
      <div className="border-b border-gray-300">
        <div className="px-4 py-5 sm:px-6 flex flex-row items-center">
          <div className="flex-1">
            <h3 className="text-lg leading-6 font-medium text-gray-900">
              Your are logged in as
            </h3>
            <p className="mt-1 max-w-2xl text-sm text-gray-500">
              {sessionInfo?.webId}
            </p>
          </div>
          <div>
            <Button loading={logoutState === 'pending'} onClick={handleLogout}>
              Log out
            </Button>
          </div>
        </div>
      </div>

      {children}
    </div>
  )
}
